import { useState } from "react"

export const InquiriesState = () => {
	const [inquiries, setInquiries] = useState({
        inquiriesList: [],
        inquiriesLoader: false,
        inquiriesModal: false,
        inquiriesWebId: null,
        inquiresInftScroll: true,
        inquiresIsLoading: false,
        inquiriesCooldown: false,
        inquiriesHasMore: true,
        inquiriesLastId: 0,
    })
	return {
		inquiries: { data: inquiries, set: setInquiries },
	}
}
